import classNames from 'clsx'
import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from 'prop-types'
import { Fragment } from 'react'

import IconTick from 'views/components/atoms/Icon/IconTick'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import { isUseMarketplaceVolumeBasedPricesEnabled } from 'views/utils/featureToggleUtils'

import VolumePricingLabelQuantitySelection from './VolumePricingQuantitySelection/VolumePricingLabelQuantitySelection'
import './VolumePricingQuantitySelection/VolumePricingLabelQuantitySelection.scss'

const OptionContent = ({
  value,
  text,
  disabled,
  title,
  defaultValue,
  allowLinks,
  onClick,
  isInStock,
  upid,
  volumePricing,
  basePrice,
  selectedValue,
}) => {
  const {
    publicRuntimeConfig: {
      pageProperties: { featureToggles },
    },
  } = useShopAndRuntimeConfig()

  const isSelected = value === defaultValue
  const isVolumePricingAvailable =
    isUseMarketplaceVolumeBasedPricesEnabled(featureToggles) &&
    volumePricing?.length > 1
  const itemClassName = classNames(
    'm-Select__item l-flex l-flex--distribute-space u-font-weight--bold u-color--dark u-position--relative',
    {
      'm-Select__item--selectable': !disabled,
      'm-Select__item--disabled': disabled,
      'm-Select__item--selected m-Select__item--highlighted': isSelected,
      'u-background-color--greyLight m-Select__item--title': title,
      'u-color--grey': !isInStock,
      'm-Select__item--volume-pricing': isVolumePricingAvailable,
    }
  )
  const isLink = allowLinks && !title
  const Container = isLink ? 'a' : Fragment
  const linkProps = isLink
    ? { className: 'm-Select__item--link', href: value }
    : {}

  const BasicSelectContainer = () => {
    return (
      <Container {...linkProps}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */}
        <div
          role="option"
          data-clientside-hook="select-item"
          className={itemClassName}
          data-value={value}
          aria-selected={isSelected ? 'true' : 'false'}
          aria-disabled={disabled ? 'true' : 'false'}
          onClick={onClick}
          data-upid={upid}
        >
          <span>{text}</span>
          <div className="m-Select__item--icon u-transform-center--y">
            <IconTick size="small" className="u-color--positive" />
          </div>
        </div>
      </Container>
    )
  }

  return isVolumePricingAvailable ? (
    <div className="m-Select__item--volume-pricing rebranding">
      <BasicSelectContainer />
      <div className="m-Select__item--selectable m-select__quantity-label--container">
        <VolumePricingLabelQuantitySelection
          value={value}
          volumePricing={volumePricing}
          basePrice={basePrice}
          selectedValue={selectedValue}
        />
      </div>
    </div>
  ) : (
    <BasicSelectContainer />
  )
}

OptionContent.propTypes = {
  className: string,
  value: oneOfType([string, number]),
  isSelected: bool,
  onClick: func,
  title: bool,
  disabled: bool,
  allowLinks: bool,
  text: string,
  defaultValue: oneOfType([number, string]),
  isInStock: bool,
  upid: string,
  volumePricing: arrayOf(shape({})),
  basePrice: number,
  selectedValue: number,
}

OptionContent.defaultProps = {
  className: '',
  value: '',
  isSelected: false,
  onClick: null,
  title: false,
  disabled: false,
  allowLinks: false,
  text: '',
  defaultValue: '',
  isInStock: true,
  volumePricing: null,
  basePrice: null,
  selectedValue: null,
}

export default OptionContent
